import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { PublicRoutingModule } from "./public-routing.module";
import { DataEntryPageComponent } from "./surveys/data-entry-page/data-entry-page.component";
import { SearchByKeyPageComponent } from "./surveys/search-by-key-page/search-by-key-page.component";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { SurveyModule } from "../shared/survey/survey.module";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ParentSearchByKeyPageComponent } from "./surveys/parent-search-by-key-page/parent-search-by-key-page.component";
import { ThankYouPageComponent } from "./surveys/thank-you-page/thank-you-page.component";

@NgModule({
  declarations: [
    SearchByKeyPageComponent,
    DataEntryPageComponent,
    ParentSearchByKeyPageComponent,
    ThankYouPageComponent,
  ],
  imports: [
    CommonModule,
    SurveyModule,
    PublicRoutingModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  exports: [
    SearchByKeyPageComponent,
    DataEntryPageComponent,
    PublicRoutingModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: "en-US" }],
})
export class PublicModule {}
